/**
 * Aktivite feed / canlı popup — görsel hiyerarşi ve nadirlik vurgusu (salt UI).
 */

import { rarityKey } from './collectionUi';

/** ISO tarih → göreli süre (tr) */
export function formatRelativeTimeTr(iso) {
  if (!iso || typeof iso !== 'string') return '';
  try {
    const t = new Date(iso.replace('Z', '+00:00')).getTime();
    const s = Math.floor((Date.now() - t) / 1000);
    if (s < 45) return 'Az önce';
    if (s < 3600) return `${Math.floor(s / 60)} dk önce`;
    if (s < 86400) return `${Math.floor(s / 3600)} sa. önce`;
    if (s < 604800) return `${Math.floor(s / 86400)} gün önce`;
    return new Date(t).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
  } catch {
    return '';
  }
}

/** Küçük kart / popup için tek görsel URL (API snapshot alanları). */
export function pickActivityThumbnail(ev) {
  if (!ev || !ev.event_type) return null;
  const u = (x) => (typeof x === 'string' && x.trim() ? x.trim() : null);
  switch (ev.event_type) {
    case 'item_equip':
      return u(ev.item_image) || u(ev.asset_image) || u(ev.character_image);
    case 'collection_score_milestone':
      return null;
    default:
      return u(ev.asset_image) || u(ev.character_image) || u(ev.item_image);
  }
}

/** Kenar + hafif glow (Tailwind); milestone nadirliksiz → nötr premium. */
export function feedAccentClasses(ev, opts = {}) {
  const enableGlow = opts.enableGlow !== false;
  const neutral =
    'border-white/12 bg-black/35 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.06)]';
  if (!ev) return { frame: neutral, glow: '', emphasis: 'normal' };
  if (ev.event_type === 'collection_score_milestone') {
    return {
      frame: `${neutral} border-violet-500/20`,
      glow: enableGlow ? 'shadow-[0_0_24px_-10px_rgba(139,92,246,0.25)]' : '',
      emphasis: 'milestone',
    };
  }
  const rk = rarityKey(ev.asset_rarity);
  const map = {
    common: {
      frame: neutral,
      glow: enableGlow ? '' : '',
      emphasis: 'low',
    },
    rare: {
      frame: 'border-blue-500/35 bg-black/40',
      glow: enableGlow ? 'shadow-[0_0_22px_-10px_rgba(59,130,246,0.28)]' : '',
      emphasis: 'medium',
    },
    epic: {
      frame: 'border-violet-500/40 bg-black/40',
      glow: enableGlow ? 'shadow-[0_0_26px_-8px_rgba(139,92,246,0.32)]' : '',
      emphasis: 'high',
    },
    legendary: {
      frame: 'border-amber-500/50 bg-black/35',
      glow: enableGlow ? 'shadow-[0_0_30px_-6px_rgba(245,158,11,0.38)]' : '',
      emphasis: 'high',
    },
    mythic: {
      frame: 'border-pink-500/45 bg-black/35',
      glow: enableGlow ? 'shadow-[0_0_32px_-4px_rgba(236,72,153,0.42)]' : '',
      emphasis: 'max',
    },
  };
  const hit = map[rk] || map.common;
  if (ev.event_type === 'rare_drop' && (rk === 'legendary' || rk === 'mythic')) {
    return {
      ...hit,
      emphasis: 'max',
      glow: enableGlow ? `${hit.glow || ''} ring-1 ring-white/10` : '',
    };
  }
  return hit;
}
